import React, { useState, useContext, useEffect } from "react";
import { AuthContext } from "../context/auth";
import axios from "axios";
import Expendedores from "./expendedores";
import Footers from "../pages/foothers";
import AuthRoute from "../util/AuthRoute";
import AsignaTimbres from "./asgtimbresf";
import Inicio from "./Inicio";
import Expeminas from "./expeminas";
import Entes from "./entes";
import Fiscales from "./fiscales";
import Impuestox from "./impuestox500";
import Impuestopro from "./impuestoproduccion";
import ImpuestoProDeclarar from "./impuestoproducciondeclarar";
import ClassMinas from "./claseminas";
import ClassProduc from "./claseproduc";
import GenerarPlanillaTImbre from "../components/timbres/gestionarPlanillasTimbres";
import AnularTimbres from "../components/timbres/anularTimbres";
import ConfVecha from "./configfechamina";
import ConfVechapro from "./configfechaproc";
import Retencion from "./retencion1x500";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Header2 from "../components/Header2";
import { Mensaje } from "../components/mensajes";
import ProcedimientoFiscal from "./procedimientoFiscal";
import Retencionfecha from "./fecharetencion";
import CajaIngresos from "./cajaingresos";
import TablaBancos from "../components/banco/tablaBancos";
import TablaCuentasBancarias from "../components/banco/tabalCuentasBancarias";
import TablaClasifiacdorMultas from "../components/multas/tablaClasificadorMultas";
import TablaClasifiacdorTasas from "../components/tasas/tablaClasificadorTasas";
import DesasignaTimbres from "./desasgtimbres";
import CatgProgramatica from "./categoriaprogramatica";
import ClassPresupuestaria from "./clasesPresupuestaria";
import TablaAsignacionMulta from "../components/multas/tablaAsignacionMulta";
import TablaAsignacionTasa from "../components/tasas/tablaAsignacionTasa";
import AnularTimbreFiscal from "./anulartimbrefiscal";
import VentaTimbreFiscal from "./ventaTimbreFiscal";
import EjeFiscal from "./ejercfiscal";
import CrearPresupuesto from "./crearpresupuesto";
import VerificarPago from "./verificacion";
import Inmuebles from "./inmuebles";
import EstadoCuentaProduc from "./estadocuentaproduc";
import EstadoCuentaMinas from "./estadocuentamina";
import EstadoCuenta1x500 from "./estadocuenta1x500";
import RentasInmobiliarias from "./rentainmibiliaria";
import EstadoCuentaExpendedor from "./estadocuentaexpendedor";
import TablaUsuariosTimbres from "../components/permisosMdulos/tablaUsurioImbres.";
import GenerarDeudaPlanillas from "../components/timbres/generarDeudaPlanillas";
import TablaUsuariosProduccion from "../components/permisosMdulos/tablaUsuarrioProduccion";
import TablaUsuariosMinas from "../components/permisosMdulos/tablaUsuariosMinas";
import TablaUsuarios1x500 from "../components/permisosMdulos/tablaUsuario1x500";
import TablaUsuariosFiscal from "../components/permisosMdulos/tablaUsuariosFiscal";
import TablaUsuariosGestion from "../components/permisosMdulos/tablaUsuarioGestion";
import TablaUsuariosPresu from "../components/permisosMdulos/ tablaUsuarioPresu";
import TablaEstadoCuentaInmuebles from "../components/rentas/tablaEstadoCuenta";
import TablaTributaria from "../components/registroEstadalTributario/tablaEstadalTributaria";
import AsignarGuias from "./asignacionguias";
import GenerarGuiasMovilizacion from "../components/guiasmovilizacion/gestionarGuiasMovilizacion";
import DeclaracionMina from "./declaracionmina";
import TablaUsuariosRentas from "../components/permisosMdulos/tablaUsuarioRentas";
import TablaUsuariosEstadal from "../components/permisosMdulos/tablaUsuarioEstadal";
import Solvencia from "./solicitud_solvencia";
import TablaUsuarioSolvencia from "../components/permisosMdulos/tablaUsuarioSolvencia";
import TimbreFiscalElectronico from "./timbre_fiscal_electronico";
import TimbreEntes from "./timbre_entes";
import TimbreDependencias from "./timbre_dependencias";
import TimbreTramites from "./timbre_tramites";
import TablaUsuarioTimbreElectronico from "../components/permisosMdulos/tablaUsuarioTimbreElectronico";
import TimbreTipoEntes from "./timbre_tipoentes";
import TablaActualizarDeuda1x1000 from "../components/impuesto1x500/tablaActualizaDeuda1x1000";
import TablaActualizarDeudaMina from "../components/minas/tablaActualizaDeudaMina";
import Inspecciones from "../components/fiscales/inspecciones";
import TablaSolicitudGuias from "../components/solicitudGuias/tablaSolicitudGuias";

function Escritorio() {
  const op = require("../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const { user, logout } = useContext(AuthContext);
  const pathname = window.location.pathname;
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
  const efiseleccionado = JSON.parse(localStorage.getItem("efiseleccionado"));

  pathname === "/" ? "login" : pathname.substr(1);
  const [path, setPath] = useState(pathname.substr(1));
  const [activate, setActivate] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
  });
  const [titulo, setTitulo] = useState();
  const accimpproduccion = JSON.parse(localStorage.getItem("accimpproduccion"));
  const acctimbresfis = JSON.parse(localStorage.getItem("acctimbresfis"));
  const accpdftimbres = JSON.parse(localStorage.getItem("accpdftimbres"));
  const permisos = JSON.parse(localStorage.getItem("permisos"));
  const accconfigtimbres = JSON.parse(localStorage.getItem("accconfigtimbres"));
  const accconfigproducc = JSON.parse(localStorage.getItem("accconfigproducc"));
  const accpdfproducc = JSON.parse(localStorage.getItem("accpdfproducc"));
  const accimpminas = JSON.parse(localStorage.getItem("accimpminas"));
  const accconfigminas = JSON.parse(localStorage.getItem("accconfigminas"));
  const accimp1x500 = JSON.parse(localStorage.getItem("accimp1x500"));
  const accconfig1x500 = JSON.parse(localStorage.getItem("accconfig1x500"));
  const accpdf1x500 = JSON.parse(localStorage.getItem("accpdf1x500"));
  const accpdfminas = JSON.parse(localStorage.getItem("accpdfminas"));
  const accfiscal = JSON.parse(localStorage.getItem("accfiscal"));
  const accconfigfiscal = JSON.parse(localStorage.getItem("accconfigfiscal"));
  const accpdffiscal = JSON.parse(localStorage.getItem("accpdffiscal"));
  const accgestion = JSON.parse(localStorage.getItem("accgestion"));

  const accrentasinm = JSON.parse(localStorage.getItem("accrentasinm"));

  const accconfiggestion = JSON.parse(localStorage.getItem("accconfiggestion"));
  const accpdfgestion = JSON.parse(localStorage.getItem("accpdfgestion"));
  const accpresupuesto = JSON.parse(localStorage.getItem("accpresupuesto"));
  const accconfigpresu = JSON.parse(localStorage.getItem("accconfigpresu"));
  const accpdfpresu = JSON.parse(localStorage.getItem("accpdfpresu"));

  const acctimbreelectromod = JSON.parse(
    localStorage.getItem("acctimbreelectromod")
  );
  const accconfigtimbreelectro = JSON.parse(
    localStorage.getItem("accconfigtimbreelectro")
  );
  const accopsolvencia = JSON.parse(localStorage.getItem("accopsolvencia"));
  const accconfigsolvencia = JSON.parse(
    localStorage.getItem("accconfigsolvencia")
  );

  const cambiar = (c) => {
    setPath(c);
    setTitulo(c);
  };

  const actualizarFechasiVenMinas = (fecha) => {
    let endpoint = `${op.conexion}/api/comun/fechasisvenminas?fecha=${fecha}`;
    axios
      .post(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.status == 200) {
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: error.response.data.message,
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const actualizarFechasiVenQuinMinas = (fecha) => {
    let endpoint = `${op.conexion}/api/comun/fechasisvenquinminas?fecha=${fecha}`;
    axios
      .post(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.status == 200) {
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: error.response.data.message,
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const actualizarFechasiVenProd = (fecha) => {
    let endpoint = `${op.conexion}/api/comun/fechasisvenprod?fecha=${fecha}`;

    axios
      .post(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.status == 200) {
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: error.response.data.message,
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const actualizarFechasiVenQuinProd = (fecha) => {
    let endpoint = `${op.conexion}/api/comun/fechasisvenquinprod?fecha=${fecha}`;
    axios
      .post(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.status == 200) {
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: error.response.data.message,
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const SeleccionarEfiscal = () => {
    setActivate(true);

    let endpoint = `${op.conexion}/api/comun/`;
    console.log(endpoint);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          var idefiscal = response.data[0].idefiscal;
          var descriptor = response.data[0].descriptor;
          var anio = response.data[0].anio;
          var observaciones = response.data[0].observaciones;
          var statusorg = response.data[0].statusorg;
          var statuspresup = response.data[0].statuspresup;
          var statuspuc = response.data[0].statuspuc;
          var statuscat = response.data[0].statuscat;
          var idorganizacion = response.data[0].idorganizacion;

          localStorage.setItem("idefiscal", idefiscal);
          localStorage.setItem("efiscaldes", descriptor);
          localStorage.setItem("efiscalanio", anio);
          localStorage.setItem("efiseleccionado", true);
          localStorage.setItem("statuspresup", statuspresup);
          localStorage.setItem("statuspuc", statuspuc);
          localStorage.setItem("statuscat", statuscat);
          localStorage.setItem("statusorg", statusorg);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  useEffect(() => {
    actualizarFechasiVenMinas(fechaSistema);
    actualizarFechasiVenQuinMinas(fechaSistema);
    actualizarFechasiVenProd(fechaSistema);
    actualizarFechasiVenQuinProd(fechaSistema);
  }, []);

  useEffect(() => {
    if (pathname === "/expendedores") {
      if (acctimbresfis && acctimbresfis.substring(0, 1) === "0") {
        window.location.href = "/inicio";
      } else {
        setTitulo("Registro de Expendedores");
      }
    } else if (pathname === "/timbrefiscalelectronico") {
      if (acctimbreelectromod && acctimbreelectromod.substring(0, 1) === "0") {
        window.location.href = "/inicio";
      } else {
        setTitulo("Solicitud Timbre Electronico");
      }
    } else if (pathname === "/timbrefiscalentes") {
      if (acctimbreelectromod && acctimbreelectromod.substring(1, 2) === "0") {
        window.location.href = "/inicio";
      } else {
        setTitulo("Registro de Entes");
      }
    } else if (pathname === "/timbrefiscaldependencias") {
      if (acctimbreelectromod && acctimbreelectromod.substring(2, 3) === "0") {
        window.location.href = "/inicio";
      } else {
        setTitulo("Registro Dependencias");
      }
    } else if (pathname === "/timbrefiscaltramites") {
      if (acctimbreelectromod && acctimbreelectromod.substring(3, 4) === "0") {
        window.location.href = "/inicio";
      } else {
        setTitulo("Registro Tramites");
      }
    } else if (pathname === "/permisostimbreelectronico") {
      if (
        accconfigtimbreelectro &&
        accconfigtimbreelectro.substring(0, 1) === "0"
      ) {
        window.location.href = "/inicio";
      } else {
        setTitulo("Permisos Timbre Electronico");
      }
    } else if (pathname === "/permisossolvencia") {
      if (accconfigsolvencia && accconfigsolvencia.substring(0, 1) === "0") {
        window.location.href = "/inicio";
      } else {
        setTitulo("Permisos Solvencia");
      }
    } else if (pathname === "/solvencia") {
      if (accopsolvencia && accopsolvencia.substring(0, 1) === "0") {
        window.location.href = "/inicio";
      } else {
        setTitulo("Solicitud Solvencia");
      }
    } else if (pathname === "/entes") {
      if (acctimbresfis && acctimbresfis.substring(1, 2) === "0") {
        window.location.href = "/inicio";
      } else {
        setTitulo("Registro de Entes");
      }
    } else if (pathname === "/generarPlanilla/TF") {
      if (acctimbresfis && acctimbresfis.substring(2, 3) === "0") {
        window.location.href = "/inicio";
      } else {
        setTitulo("Generación de Timbres Fiscales");
      }
    } else if (pathname === "/asgtimbres/TF") {
      if (acctimbresfis && acctimbresfis.substring(3, 4) === "0") {
        window.location.href = "/inicio";
      } else {
        setTitulo("Asignación de Timbres Fiscales");
      }
    } else if (pathname === "/desasgtimbres/TF") {
      if (acctimbresfis && acctimbresfis.substring(4, 5) === "0") {
        window.location.href = "/inicio";
      } else {
        setTitulo("Desasignación de Timbres Fiscales");
      }
    } else if (pathname === "/anulartimbrefiscal/TF") {
      if (acctimbresfis && acctimbresfis.substring(5, 6) === "0") {
        window.location.href = "/inicio";
      } else {
        setTitulo("Anulación de Timbres Fiscales");
      }
    } else if (pathname === "/permisosrentas") {
      setTitulo("Permisos Usuarios Rentas Inmobiliarias");
    } else if (pathname === "/permisosrestadal") {
      setTitulo("Permisos Usuarios Estadal Tributario");
    } else if (pathname === "/ventatimbres/TF") {
      if (acctimbresfis && acctimbresfis.substring(5, 6) === "0") {
        window.location.href = "/inicio";
      } else {
        setTitulo("Venta de Timbres Fiscales");
      }
    } else if (pathname === "/generarDeudaPlanilla/TF") {
      if (acctimbresfis && acctimbresfis.substring(7, 8) === "0") {
        window.location.href = "/inicio";
      } else {
        setTitulo("Generar Deuda TF");
      }
    } else if (pathname === "/producccion") {
      if (accimpproduccion && accimpproduccion.substring(0, 1) === "0") {
        window.location.href = "/inicio";
      } else {
        setTitulo("Registro de Contribuyentes por Producción");
      }
    } else if (pathname === "/declaracionProduccion") {
      if (accimpproduccion && accimpproduccion.substring(1, 2) === "0") {
        window.location.href = "/inicio";
      } else {
        setTitulo("Declaraciones por Contribuyentes Producción");
      }
    } else if (pathname === "/producclass") {
      if (accimpproduccion && accimpproduccion.substring(2, 3) === "0") {
        window.location.href = "/inicio";
      } else {
        setTitulo("Clasificador Impuesto Producción");
      }
    } else if (pathname === "/fechavencpro") {
      if (accconfigproducc && accconfigproducc.substring(2, 3) === "0") {
        window.location.href = "/inicio";
      } else {
        setTitulo("Fechas de Vencimiento Producción");
      }
    } else if (pathname === "/minas") {
      if (accimpminas && accimpminas.substring(0, 1) === "0") {
        window.location.href = "/inicio";
      } else {
        setTitulo("Registro de Contribuyentes por Minas");
      }
    } else if (pathname === "/declaracionMinas") {
      if (accimpminas && accimpminas.substring(1, 2) === "0") {
        window.location.href = "/inicio";
      } else {
        setTitulo("Declaraciones Contribuyentes Minas");
      }
    } else if (pathname === "/minaclass") {
      if (accimpminas && accimpminas.substring(2, 3) === "0") {
        window.location.href = "/inicio";
      } else {
        setTitulo("Clasificador del Impuesto Minas");
      }
    } else if (pathname === "/generarPlanilla/GM") {
      if (accimpminas && accimpminas.substring(3, 4) === "0") {
        window.location.href = "/inicio";
      } else {
        setTitulo("Generación de Guia De Movilizacion");
      }
    } else if (pathname === "/asgtimbres/GM") {
      if (accimpminas && accimpminas.substring(4, 5) === "0") {
        window.location.href = "/inicio";
      } else {
        setTitulo("Asignación de Guia De Movilizacion");
      }
    } else if (pathname === "/desasgtimbres/GM") {
      if (accimpminas && accimpminas.substring(5, 6) === "0") {
        window.location.href = "/inicio";
      } else {
        setTitulo("Desasignación de Guia De Movilizacion");
      }
    } else if (pathname === "/anulartimbrefiscal/GM") {
      if (accimpminas && accimpminas.substring(6, 7) === "0") {
        window.location.href = "/inicio";
      } else {
        setTitulo("Anulacion de Guia De Movilizacion");
      }
    } else if (pathname === "/ventatimbres/GM") {
      if (accimpminas && accimpminas.substring(7, 8) === "0") {
        window.location.href = "/inicio";
      } else {
        setTitulo("Venta de Guia De Movilizacion");
      }
    } else if (pathname === "/generarDeudaPlanilla/GM") {
      if (accimpminas && accimpminas.substring(8, 9) === "0") {
        window.location.href = "/inicio";
      } else {
        setTitulo("Generar Deuda GM");
      }
    } else if (pathname === "/fechavenc") {
      if (accconfigminas && accconfigminas.substring(2, 3) === "0") {
        window.location.href = "/inicio";
      } else {
        setTitulo("Fechas de Vencimiento Minas");
      }
    } else if (pathname === "/1x500") {
      if (accimp1x500 && accimp1x500.substring(0, 1) === "0") {
        window.location.href = "/inicio";
      } else {
        setTitulo("Registro de Agentes/Retención");
      }
    } else if (pathname === "/reten1x500") {
      if (accimp1x500 && accimp1x500.substring(1, 2) === "0") {
        window.location.href = "/inicio";
      } else {
        setTitulo("Retención 1x1000");
      }
    } else if (pathname === "/fechareten") {
      if (accconfig1x500 && accconfig1x500.substring(2, 3) === "0") {
        window.location.href = "/inicio";
      } else {
        setTitulo("Fechas de Vencimiento 1x1000");
      }
    } else if (pathname === "/fiscales") {
      if (accfiscal && accfiscal.substring(0, 1) === "0") {
        window.location.href = "/inicio";
      } else {
        setTitulo("Registro de Fiscales");
      }
    } else if (pathname === "/aperturaprocedimiento") {
      if (accfiscal && accfiscal.substring(1, 2) === "0") {
        window.location.href = "/inicio";
      } else {
        setTitulo("Apertura de Procedimiento Fiscal");
      }
    } else if (pathname === "/bancos") {
      if (accgestion && accgestion.substring(1, 2) === "0") {
        window.location.href = "/inicio";
      } else {
        setTitulo("Bancos");
      }
    } else if (pathname === "/cuentasbancarias") {
      if (accgestion && accgestion.substring(2, 3) === "0") {
        window.location.href = "/inicio";
      } else {
        setTitulo("Cuentas Bancarias");
      }
    } else if (pathname === "/clasificadormultas") {
      if (accfiscal && accfiscal.substring(2, 3) === "0") {
        window.location.href = "/inicio";
      } else {
        setTitulo("Clasificador de Multas");
      }
    } else if (pathname === "/categoriaprogramatica") {
      if (accpresupuesto && accpresupuesto.substring(1, 2) === "0") {
        window.location.href = "/inicio";
      } else {
        setTitulo("Actualizar Categorias Programaticas");
      }
    } else if (pathname === "/asignarmulta") {
      if (accfiscal && accfiscal.substring(3, 4) === "0") {
        window.location.href = "/inicio";
      } else {
        setTitulo("Asignación de Multas");
      }
    } else if (pathname === "/clasificadortasas") {
      if (accfiscal && accfiscal.substring(2, 3) === "0") {
        window.location.href = "/inicio";
      } else {
        setTitulo("Clasificador de Tasas");
      }
    } else if (pathname === "/asignartasa") {
      if (accfiscal && accfiscal.substring(3, 4) === "0") {
        window.location.href = "/inicio";
      } else {
        setTitulo("Asignación de Tasas");
      }
    } else if (pathname === "/classpresupuestaria") {
      if (accpresupuesto && accpresupuesto.substring(2, 3) === "0") {
        window.location.href = "/inicio";
      } else {
        setTitulo("Actualizar Clasificador Presupuestario");
      }
    } else if (pathname === "/ejerfiscal") {
      if (accpresupuesto && accpresupuesto.substring(0, 1) === "0") {
        window.location.href = "/inicio";
      } else {
        setTitulo("Ejercicio Fiscal");
      }
    } else if (pathname === "/permisostimbres") {
      if (accconfigtimbres && accconfigtimbres.substring(0, 1) === "0") {
        window.location.href = "/inicio";
      } else {
        setTitulo("Permisos Usuarios Timbres");
      }
    } else if (pathname === "/permisosproduccion") {
      if (accconfigproducc && accconfigproducc.substring(0, 1) === "0") {
        window.location.href = "/inicio";
      } else {
        setTitulo("Permisos Usuarios Producción");
      }
    } else if (pathname === "/permisosminas") {
      if (accconfigminas && accconfigminas.substring(0, 1) === "0") {
        window.location.href = "/inicio";
      } else {
        setTitulo("Permisos Usuarios Minas");
      }
    } else if (pathname === "/inicio") {
      if (efiseleccionado === false) {
        SeleccionarEfiscal();
      }
    } else if (pathname === "/permisos1x500") {
      if (accconfig1x500 && accconfig1x500.substring(0, 1) === "0") {
        window.location.href = "/inicio";
      } else {
        setTitulo("Permisos Usuarios 1x1000");
      }
    } else if (pathname === "/permisosgestion") {
      if (accconfiggestion && accconfiggestion.substring(0, 1) === "0") {
        window.location.href = "/inicio";
      } else {
        setTitulo("Permisos Usuarios Ingresos Diarios");
      }
    } else if (pathname === "/permisosfiscal") {
      if (accconfigfiscal && accconfigfiscal.substring(0, 1) === "0") {
        window.location.href = "/inicio";
      } else {
        setTitulo("Permisos Usuarios Fiscales");
      }
    } else if (pathname === "/crearpresu") {
      if (accpresupuesto && accpresupuesto.substring(3, 4) === "0") {
        window.location.href = "/inicio";
      } else {
        setTitulo("Gestión de Presupuesto");
      }
    } else if (pathname === "/permisospresupuesto") {
      if (accconfigpresu && accconfigpresu.substring(0, 1) === "0") {
        window.location.href = "/inicio";
      } else {
        setTitulo("Permisos Usuarios Presupuesto");
      }
    } else if (pathname === "/verificarpago") {
      if (accgestion && accgestion.substring(4, 5) === "0") {
        window.location.href = "/inicio";
      } else {
        setTitulo("Verificación de Pagos");
      }
    } else if (pathname === "/producestadocuenta") {
      if (accgestion && accgestion.substring(4, 5) === "0") {
        window.location.href = "/inicio";
      } else {
        setTitulo("Estados de Cuenta Producción");
      }
    } else if (pathname === "/minasestadodecuenta") {
      if (accgestion && accgestion.substring(4, 5) === "0") {
        window.location.href = "/inicio";
      } else {
        setTitulo("Estados de Cuenta Minas");
      }
    } else if (pathname === "/stadocuenta1x500") {
      if (accgestion && accgestion.substring(4, 5) === "0") {
        window.location.href = "/inicio";
      } else {
        setTitulo("Estados de Cuenta 1x1000");
      }
    } else if (pathname === "/expendedorestadocuenta") {
      if (accgestion && accgestion.substring(4, 5) === "0") {
        window.location.href = "/inicio";
      } else {
        setTitulo("Estados de Cuenta Expendedores");
      }
    } else if (pathname === "/inmmorentas") {
      if (accgestion && accgestion.substring(4, 5) === "0") {
        window.location.href = "/inicio";
      } else {
        setTitulo("Registro de Rentas Inmobiliarias");
      }
    } else if (pathname === "/inmmuebles") {
      if (accrentasinm && accrentasinm.substring(0, 1) === "0") {
        window.location.href = "/inicio";
      } else {
        setTitulo("Registros de Inmuebles");
      }
    } else if (pathname === "/estadoinmu") {
      if (accgestion && accgestion.substring(4, 5) === "0") {
        window.location.href = "/inicio";
      } else {
        setTitulo("Estados de Cuenta de Rentas Inmobiliarias");
      }
    }
    //cuentasbancarias
  }, [pathname]);

  const menu = (
    <div>
      <div className="d-flex bluex-bg" id="wrapper">
        {path === "inicio" ? <Sidebar onCambiar={cambiar} /> : ""}
        <div id="page-content-wrapper">
          {path === "inicio" ? (
            <Header onCambiar={cambiar} />
          ) : (
            <Header2 titulo={titulo} onCambiar={cambiar} />
          )}

          <div className="w-100 h-100 p-0" id="scrol">
            <AuthRoute exact path="/inicio" component={Inicio} />
            <AuthRoute exact path="/expendedores" component={Expendedores} />
            <AuthRoute
              exact
              path="/asgtimbres/:tipo"
              component={AsignaTimbres}
            />
            <AuthRoute
              exact
              path="/desasgtimbres/:tipo"
              component={DesasignaTimbres}
            />
            <AuthRoute exact path="/minas" component={Expeminas} />
            <AuthRoute
              exact
              path="/asignacionguias/:tipo"
              component={AsignarGuias}
            />
            <AuthRoute exact path="/1x500" component={Impuestox} />
            <AuthRoute exact path="/producccion" component={Impuestopro} />
            <AuthRoute exact path="/minaclass" component={ClassMinas} />
            <AuthRoute exact path="/producclass" component={ClassProduc} />
            <AuthRoute exact path="/fechavenc" component={ConfVecha} />
            <AuthRoute exact path="/fechareten" component={Retencionfecha} />
            <AuthRoute exact path="/fechavencpro" component={ConfVechapro} />
            <AuthRoute exact path="/reten1x500" component={Retencion} />
            <AuthRoute exact path="/entes" component={Entes} />
            <AuthRoute exact path="/fiscales" component={Fiscales} />
            <AuthRoute
              exact
              path="/declaracionProduccion"
              component={ImpuestoProDeclarar}
            />
            <AuthRoute
              exact
              path="/declaracionMinas"
              component={DeclaracionMina}
            />
            <AuthRoute
              exact
              path="/guiamovilizacion"
              component={GenerarGuiasMovilizacion}
            />
            <AuthRoute
              exact
              path="/generarPlanilla/:tipo"
              component={GenerarPlanillaTImbre}
            />
            <AuthRoute
              exact
              path="/generarDeudaPlanilla/:tipo"
              component={GenerarDeudaPlanillas}
            />
            <AuthRoute exact path="/anularTimbre" component={AnularTimbres} />
            <AuthRoute
              exact
              path="/aperturaprocedimiento"
              component={ProcedimientoFiscal}
            />
            <AuthRoute exact path="/cajaingresos" component={CajaIngresos} />
            <AuthRoute exact path="/bancos" component={TablaBancos} />
            <AuthRoute
              exact
              path="/cuentasbancarias"
              component={TablaCuentasBancarias}
            />
            <AuthRoute
              exact
              path="/clasificadormultas"
              component={TablaClasifiacdorMultas}
            />
            <AuthRoute
              exact
              path="/categoriaprogramatica"
              component={CatgProgramatica}
            />
            <AuthRoute
              exact
              path="/classpresupuestaria"
              component={ClassPresupuestaria}
            />
            <AuthRoute
              exact
              path="/asignarmulta"
              component={TablaAsignacionMulta}
            />
            <AuthRoute
              exact
              path="/asignartasa"
              component={TablaAsignacionTasa}
            />
            <AuthRoute
              exact
              path="/clasificadortasas"
              component={TablaClasifiacdorTasas}
            />
            <AuthRoute
              exact
              path="/anulartimbrefiscal/:tipo"
              component={AnularTimbreFiscal}
            />
            <AuthRoute
              exact
              path="/ventatimbres/:tipo"
              component={VentaTimbreFiscal}
            />
            <AuthRoute exact path="/ejerfiscal" component={EjeFiscal} />
            <AuthRoute
              exact
              path="/permisostimbres"
              component={TablaUsuariosTimbres}
            />
            <AuthRoute
              exact
              path="/permisosrestadal"
              component={TablaUsuariosEstadal}
            />
            <AuthRoute
              exact
              path="/permisossolvencia"
              component={TablaUsuarioSolvencia}
            />
            <AuthRoute
              exact
              path="/permisostimbreElectronico"
              component={TablaUsuarioTimbreElectronico}
            />
            <AuthRoute
              exact
              path="/permisosproduccion"
              component={TablaUsuariosProduccion}
            />
            <AuthRoute
              exact
              path="/permisosminasx"
              component={TablaUsuariosMinas}
            />
            <AuthRoute
              exact
              path="/permisosrentas"
              component={TablaUsuariosRentas}
            />
            <AuthRoute exact path="/crearpresu" component={CrearPresupuesto} />
            <AuthRoute
              exact
              path="/permisosminas"
              component={TablaUsuariosMinas}
            />
            <AuthRoute
              exact
              path="/permisos1x500"
              component={TablaUsuarios1x500}
            />
            <AuthRoute
              exact
              path="/permisosfiscal"
              component={TablaUsuariosFiscal}
            />
            <AuthRoute
              exact
              path="/permisosgestion"
              component={TablaUsuariosGestion}
            />
            <AuthRoute
              exact
              path="/permisospresupuesto"
              component={TablaUsuariosPresu}
            />
            <AuthRoute exact path="/verificarpago" component={VerificarPago} />
            <AuthRoute
              exact
              path="/producestadocuenta"
              component={EstadoCuentaProduc}
            />
            <AuthRoute
              exact
              path="/stadocuenta1x500"
              component={EstadoCuenta1x500}
            />
            <AuthRoute
              exact
              path="/minasestadodecuenta"
              component={EstadoCuentaMinas}
            />
            <AuthRoute
              exact
              path="/expendedorestadocuenta"
              component={EstadoCuentaExpendedor}
            />
            <AuthRoute
              exact
              path="/inmmorentas"
              component={RentasInmobiliarias}
            />
            <AuthRoute exact path="/inmmuebles" component={Inmuebles} />
            <AuthRoute
              exact
              path="/estadoinmu"
              component={TablaEstadoCuentaInmuebles}
            />
            <AuthRoute
              exact
              path="/registroedotributario"
              component={TablaTributaria}
            />
            <AuthRoute exact path="/solvencia" component={Solvencia} />
            <AuthRoute
              exact
              path="/timbrefiscalelectronico"
              component={TimbreFiscalElectronico}
            />
            <AuthRoute
              exact
              path="/timbrefiscalentes"
              component={TimbreEntes}
            />
            <AuthRoute
              exact
              path="/timbrefiscaldependencias"
              component={TimbreDependencias}
            />
            <AuthRoute
              exact
              path="/timbrefiscaltramites"
              component={TimbreTramites}
            />
            <AuthRoute
              exact
              path="/timbrefiscaltipoentes"
              component={TimbreTipoEntes}
            />
            <AuthRoute
              exact
              path="/actualizardeuda1x1000"
              component={TablaActualizarDeuda1x1000}
            />
            <AuthRoute
              exact
              path="/actualizardeudaminas"
              component={TablaActualizarDeudaMina}
            />
                        <AuthRoute
              exact
              path="/inspeccion"
              component={Inspecciones}
            />
             <AuthRoute
              exact
              path="/solicitudguia"
              component={TablaSolicitudGuias}
            />
          </div>
        </div>
      </div>
      <Footers />
      <Mensaje
        mensaje={mensaje}
        onHide={() => setMensaje({ mostrar: false, titulo: "", texto: "" })}
      />
    </div>
  );
  return menu;
}
export default Escritorio;



// WEBPACK FOOTER //
// ./src/pages/escritorio.js